module.exports = __webpack_public_path__ + "media/images/illustrations/processing-217d0b0f664fc53e620c716e4366bd22.svg";